module.exports = __webpack_public_path__ + "img/1.471d4637.jpg";